import React, { useState, useEffect } from 'react';
import Canvas from './components/Canvas';
import { CollaborationProvider } from './contexts/CollaborationContext';
import { ToastProvider } from './contexts/ToastContext';
import { DialogProvider } from './contexts/DialogContext';
import { I18nProvider } from './contexts/I18nContext';
import { ToastContainer } from './components/collaboration/ToastContainer';
import './styles/App.css';

function App() {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 툴바 높이를 고려한 실제 사용 가능한 높이 계산
  const [toolbarHeight, setToolbarHeight] = useState(60); // 기본값

  useEffect(() => {
    // 툴바 높이를 동적으로 측정
    const toolbar = document.querySelector('.toolbar-container');
    if (toolbar) {
      const height = toolbar.getBoundingClientRect().height;
      setToolbarHeight(height);
    }
  }, []);

  const availableHeight = dimensions.height - toolbarHeight;

  return (
    <I18nProvider>
      <ToastProvider>
        <DialogProvider>
          <CollaborationProvider serverUrl={import.meta.env.VITE_WS_SERVER_URL || 'ws://localhost:3001'}>
            <div className="App">
              <Canvas width={dimensions.width} height={availableHeight} />
              <ToastContainer />
            </div>
          </CollaborationProvider>
        </DialogProvider>
      </ToastProvider>
    </I18nProvider>
  );
}

export default App;
